import { Component, OnInit, ViewChild, ViewContainerRef,Input  } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TemplateService } from '../template.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import {FieldInsideTab} from './template';
import {FieldInsideGroup} from './template';

@Component({
  selector: 'template-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {

	public tabs;
	public sections;
	public groups;
	public fields;
	public fieldsOne;
	public values;
	public ta;
	public openData;
	public sect;
	public section;
	public group;
	public whichActive;
	public resultantArray;
	public finalArray;
	public templateName;
	public templates;
	public templateById;
	public editTemplateById;
	public templateId;
	public temp;
	public editTemp;
	public groupDetail;
	public groupfFieldsDetail;
	public groupPopArray;
	public sectionsPopup;
	public gropusPopup;
	public tabDetail;
	public sectionDetail;
	public sectionGroupDetail;
	public groupsRecordInsidePopup;
	public isAllGroupsSelected;
	public editTemplateId;
	public searchField;
	public searchGroup;
	public searchSectionValue;
	public searchTabValue;
	public originalFieldsArray;
	public originalGroupsArray;
	public originalSectionsArray;
	public originalTabArray;


	// for options inside tab //
	public activeTabIdFieldInsideTab;
	public dataFieldInsideTab;
	public activeFieldInsideTab;
	public activeFieldInsideTabType;
	public popupForFieldsInTabs;
	public FieldInsideTabOptionName;
	public FieldInsideTabOptionValue;
	public addedFieldsInsideTabsCount;
	public fieldInsideTabArray= new Array<FieldInsideTab>();
	// ends here

	// for options inside gropus //
	public popupForFieldsInGroups;
	public activeTabIdFieldInsideGroup;
	public dataFieldInsideGroup;
	public activeFieldInsideGroup;
	public activeFieldInsideGroupType;
	// ends here

	// for options inside Section //
	public popupForFieldsInSections;
	public activeTabIdFieldInsideSection;
	public dataFieldInsideSection;
	public activeFieldInsideSection;
	public activeFieldInsideSectionType;
	public activeSectionIdFieldInsideSection;
	// ends here

	// for options inside Section group //
	public popupForFieldsInSectionsGroup;
	public activeTabIdFieldInsideSectionGroup;
	public dataFieldInsideSectionGroup;
	public activeFieldInsideSectionGroup;
	public activeFieldInsideSectionGroupType;
	public activeSectionIdFieldInsideSectionGroup;
	// ends here

	tabsGroup : any;
	activeId: string;
	activeSectionId:'';
	activeGroupId:'';
	constructor(private templateService: TemplateService, private route: ActivatedRoute,public toastr: ToastsManager, vcr: ViewContainerRef,private router: Router) {
		this.values =[];
		this.temp =[];
		this.editTemp =[];
		this.ta =[];
		this.sect =[];
		this.section ={};
		this.group ={};
		this.resultantArray =[];
		this.groupPopArray =[];
		this.templates =[];
		this.groupDetail =[];
		this.tabDetail =[];
		this.groupfFieldsDetail =[];
		this.originalFieldsArray =[];
		this.originalGroupsArray =[];
		this.originalSectionsArray =[];
		this.originalTabArray =[];
		this.groupsRecordInsidePopup =[];
		this.popupForFieldsInTabs =false;
		this.popupForFieldsInGroups =false;
		this.popupForFieldsInSections =false;
		this.popupForFieldsInSectionsGroup =false;
		this.sectionsPopup =false;
		this.gropusPopup =false;
		this.isAllGroupsSelected =false;
		this.addedFieldsInsideTabsCount =[0];
		var t : FieldInsideTab = new FieldInsideTab(0,'','');
		this.fieldInsideTabArray.push(t);
		this.toastr.setRootViewContainerRef(vcr);

		/* for edit template */

		/* ends here */

		this.templateService.fetchTemplates()
		   .subscribe(templates => {
				this.templates = templates;
		      if(window.location.href.indexOf("?") > -1){
		     this.editTemplateId = window.location.href.split("?")[1].split("=")[1];
		     this.templateService
		       .fetchTemplateById(this.editTemplateId)
		       .subscribe(editTemplateById => {
		      this.editTemplateById = editTemplateById;
		      if (this.editTemplateById) {
		       this.values=[];
		       this.editTemp=[];
		       this.editTemp.push(this.editTemplateById.templateData);
		       this.values = this.editTemp[0];
		       for(let i=0;i<templates.length;i++){
		        if(this.editTemplateId == templates[i].id){
		         this.templateName = {"id": templates[i].id,"key":templates[i].key,"name":templates[i].name};
		         console.log(this.templateName);
		        }
		       }

		      }
		       }, error => {

		       });
		    }
      });
				//  get tabs data
		/*this.templateService.fetchTabs().subscribe(
										  (tabs: any[]) => this.tabs = tabs,
										  (error) => console.log(error)
		);*/
		this.templateService.fetchTabs().subscribe(tabs => {
			this.tabs = tabs;
			this.originalTabArray = tabs;		    
        });
		//  get sections data
		/*this.templateService.fetchSections().subscribe(
										  (sections: any[]) => this.sections = sections,
										  (error) => console.log(error)
		);*/
		this.templateService.fetchSections().subscribe(sections => {
			this.sections = sections;
			this.originalSectionsArray = sections;		    
        });
		//  get Groups data
		/*this.templateService.fetchGroups().subscribe(
										  (groups: any[]) => this.groups = groups,
										  (error) => console.log(error)
		);*/
		this.templateService.fetchGroups().subscribe(groups => {
			this.groups = groups;
			this.originalGroupsArray = groups;		    
        });
		//  get Fields data
		/*this.templateService.fetchFields().subscribe(
										  (fields: any[]) => this.fields = fields,
										  (error) => console.log(error)
		);*/
		this.templateService.fetchFields().subscribe(fields => {
			this.fields = fields;
			this.originalFieldsArray = fields;
		    
      });
		

		  
	}
	templateSubmit(){
		if(this.values.length==0){
			this.toastr.error('Please add the tab at least!');
		}else{
			if(typeof this.editTemplateId != "undefined"){
				this.resultantArray =
								{
									"id": this.editTemplateId,
									"TemplateData": this.values,
									"TemplateName": this.templateName.name
								};
			this.templateService
				.editTemplate(this.resultantArray)
				.subscribe(result => {
					this.toastr.success('Tempate saved successfully');
				});
			}else{
			this.resultantArray =
								{
									"id": "",
									"TemplateData":this.values,
									"TemplateName": this.templateName
								};
			//console.log(this.resultantArray);
			this.templateService
				.createTemplate(this.resultantArray)
				.subscribe(result => {
					this.toastr.success('Tempate saved successfully');
				});
			}
		}
	}

	 map_submit(){
		if(this.values.length==0){
			this.toastr.error('Please add the tab at least!');
		}else{
			if(typeof this.editTemplateId != "undefined"){
				this.resultantArray =
								{
									"id": this.editTemplateId,
									"TemplateData": this.values,
									"TemplateName": this.templateName.name
								};

			this.templateService
				.editTemplate(this.resultantArray)
				.subscribe(result => {
					this.toastr.success('Tempate saved successfully');
					this.router.navigate(['setting/dfb/config/context-screen/create'],{queryParams : {tempName :this.templateName.name }});
				});
			}else{
			this.resultantArray =
								{
									"id": "",
									"TemplateData": this.values,
									"TemplateName": this.templateName
								};
			//console.log(this.resultantArray);
			this.templateService
				.createTemplate(this.resultantArray)
				.subscribe(result => {
					this.toastr.success('Tempate saved successfully');
					this.router.navigate(['setting/dfb/config/context-screen/create'],{queryParams : {tempName :this.templateName }});
				});
			}
		}
	 }

	verticalTab(name,id,type){
		if(type="group"){
			this.whichActive = type;
		}else{
			this.whichActive = "section";
		}
		this.activeGroupId = id;
		this.openData = name;
	}
	activeSection(){
		this.whichActive ="";
		this.whichActive ="section";
	}

	addTab(tab){
		//console.log(tab.id);
		this.sectionsPopup = false;
		// call sections in the popup according to tab
			this.templateService
					  .fetchTabDetail(tab.id)
					  .subscribe((tabDetail: any[]) => {
						this.tabDetail = tabDetail;
						//console.log(this.tabDetail);
						/*for(let i=0; i<this.groupDetail["fields"].length;i++){
							this.templateService
							  .fetchFieldsDetailsOfGroup(this.groupDetail["fields"][i])
							  .subscribe((groupfFieldsDetail: any[]) => {
								this.groupfFieldsDetail = groupfFieldsDetail;
								console.log(this.groupfFieldsDetail);

							  }, error => {

							  });
						}*/
					  }, error => {

					  });


		let tabExist = this.searchTab(tab.name);
		if(!tabExist){
			this.values.push({
						name: tab.name,
						sections:[],
						groups:[],
						fields :[]
			});

			for(let i = 0; i<this.tabs.length ; i++){
				if(tab.name == this.tabs[i]["name"]){
					this.tabs.splice(i,1);
				}
			}
		}else{
			 this.toastr.error('Tab Already exist!');
		}
	}

	searchTab(searchValue){
		let flag = false;
		for (let i=0; i < this.values.length; i++) {
			if (this.values[i].name === searchValue) {
				flag = true;
				break;
			}else{
				flag =  false;
			}
		}
		return flag;
	}

	addSection(s,activeTabID){
		if(this.values.length>0){
			//console.log(s);
			this.gropusPopup = true;
			// call api to get the sections details
			this.templateService
					  .fetchSectionDetail(s.id)
					  .subscribe((sectionDetail: any[]) => {
						this.sectionDetail = sectionDetail;
						//console.log(this.sectionDetail);
						for(let i=0; i<this.sectionDetail["groups"].length;i++){
							this.templateService
							  .fetchGroupDetailsOfSection(this.sectionDetail["groups"][i])
							  .subscribe((sectionGroupDetail: any[]) => {
								this.sectionGroupDetail = sectionGroupDetail;
								this.groupsRecordInsidePopup.push(this.sectionGroupDetail);
								//console.log(this.groupsRecordInsidePopup);

							  }, error => {

							  });
						}
					  }, error => {

					  });

			let sectionExist = this.searchSection(s.name,activeTabID);
			if(!sectionExist){
				if(this.values[activeTabID]["sections"].length==0 && this.values[activeTabID]["groups"].length > 0){
				this.toastr.error('Not valid!');
				this.gropusPopup = false;
				}else{
					let section={"name":s.name,"groups":[],"fields":[]}
					this.values[activeTabID]["sections"].push(section);
					for(let i = 0; i<this.sections.length ; i++){
						if(s.name == this.sections[i]["name"]){
							this.sections.splice(i,1);
						}
					}
				}
			}else{
				this.toastr.error('Section Already exist!');
			}
		}
		else{
			this.toastr.error('Tab Required!');
		}
	}
	searchSection(searchValue,activeTabID){
		let flagSection = false;
		for (let i=0; i < this.values[activeTabID]["sections"].length; i++) {
			if (this.values[activeTabID]["sections"][i].name === searchValue) {
				flagSection = true;
				break;
			}else{
				flagSection =  false;
			}
		}
		return flagSection;
	}

	addGroup(g,activeTabID,activeSectionId){
		if(this.values.length>0){
			var groupId;
			if(this.values[activeTabID]["sections"].length==0 || typeof activeSectionId == "undefined"){
				let groupExist = this.searchGroupWithoutSection(g.name,activeTabID);
				if(!groupExist){
					let group={"name":g.name,"fields":[]}
					this.values[activeTabID]["groups"].push(group);
					for(let i = 0; i<this.groups.length ; i++){
						if(g.name == this.groups[i]["name"]){
							this.groupPopArray.push(this.groups[i]);
							this.groups.splice(i,1);
						}
					}

					// Service to get the fields details inside groups
					var activeGroup = this.values[activeTabID]["groups"].length-1;
					if(g.id == undefined){
						for(let p=0; p<this.groupPopArray.length;p++){
							if(g.name == this.groupPopArray[p].name){
								if(this.groupPopArray[p].id != undefined){
									groupId = this.groupPopArray[p].id;
								}


							}
						}
					}else{
						groupId = g.id;
					}

					this.templateService
					  .fetchFieldsOfGroup(groupId)
					  .subscribe((groupDetail: any[]) => {
						this.groupDetail = groupDetail;
						//console.log(this.groupDetail);
						for(let i=0; i<this.groupDetail["fields"].length;i++){
							this.templateService
							  .fetchFieldsDetailsOfGroup(this.groupDetail["fields"][i])
							  .subscribe((groupfFieldsDetail: any[]) => {
								this.groupfFieldsDetail = groupfFieldsDetail;
								console.log(this.groupfFieldsDetail);

								if(this.groupfFieldsDetail.type=="select" || this.groupfFieldsDetail.type=="radio"){
									this.values[activeTabID]["groups"][activeGroup]["fields"].push({"className":this.groupfFieldsDetail.className,"key":this.groupfFieldsDetail.key,"name":this.groupfFieldsDetail.fieldName,"type":this.groupfFieldsDetail.type,"defaultValue":this.groupfFieldsDetail.defaultValue,templateOptions:{label:this.groupfFieldsDetail.fieldName,type:this.groupfFieldsDetail.type,required:false,options:[]}});
								}else{
									this.values[activeTabID]["groups"][activeGroup]["fields"].push({"className":this.groupfFieldsDetail.className,"key":this.groupfFieldsDetail.key,"name":this.groupfFieldsDetail.fieldName,"type":this.groupfFieldsDetail.type,"defaultValue":this.groupfFieldsDetail.defaultValue,templateOptions:{label:this.groupfFieldsDetail.fieldName,type:this.groupfFieldsDetail.type,required:false,minlength: this.groupfFieldsDetail.minLength,maxlength: this.groupfFieldsDetail.maxLength}});
								}


							  }, error => {

							  });
						}
					  }, error => {

					  });

				}else{
					this.toastr.error('Group Already exist!');
				}
			}
			else{
				var str = activeSectionId.toString();
				var res = str.split("-");
				//alert("there");
				let groupInsideExist = this.searchGroupInsideSection(g.name,activeTabID,res[1]);
				if(!groupInsideExist){
					let group={"name":g.name,"fields":[]}
					this.values[activeTabID]["sections"][res[1]]["groups"].push(group);
					for(let i = 0; i<this.groups.length ; i++){
						if(g.name == this.groups[i]["name"]){
							this.groupPopArray.push(this.groups[i]);
							this.groups.splice(i,1);
						}
					}
					// Service to get the fields details inside groups
					var activeGroup = this.values[activeTabID]["sections"][res[1]]["groups"].length-1;
					if(g.id == undefined){
						for(let p=0; p<this.groupPopArray.length;p++){
							if(g.name == this.groupPopArray[p].name){
								if(this.groupPopArray[p].id != undefined){
									groupId = this.groupPopArray[p].id;
								}


							}
						}
					}else{
						groupId = g.id;
					}

					this.templateService
					  .fetchFieldsOfGroup(groupId)
					  .subscribe((groupDetail: any[]) => {
						this.groupDetail = groupDetail;
						console.log(this.groupDetail);
						for(let i=0; i<this.groupDetail["fields"].length;i++){
							this.templateService
							  .fetchFieldsDetailsOfGroup(this.groupDetail["fields"][i])
							  .subscribe((groupfFieldsDetail: any[]) => {
								this.groupfFieldsDetail = groupfFieldsDetail;
								console.log(this.groupfFieldsDetail);

								if(this.groupfFieldsDetail.type=="select" || this.groupfFieldsDetail.type=="radio"){
									this.values[activeTabID]["sections"][res[1]]["groups"][activeGroup]["fields"].push({"className":this.groupfFieldsDetail.className,"key":this.groupfFieldsDetail.key,"name":this.groupfFieldsDetail.fieldName,"type":this.groupfFieldsDetail.type,"defaultValue":this.groupfFieldsDetail.defaultValue,templateOptions:{label:this.groupfFieldsDetail.fieldName,type:this.groupfFieldsDetail.type,required:false,options:[]}});
								}else{
									this.values[activeTabID]["sections"][res[1]]["groups"][activeGroup]["fields"].push({"className":this.groupfFieldsDetail.className,"key":this.groupfFieldsDetail.key,"name":this.groupfFieldsDetail.fieldName,"type":this.groupfFieldsDetail.type,"defaultValue":this.groupfFieldsDetail.defaultValue,templateOptions:{label:this.groupfFieldsDetail.fieldName,type:this.groupfFieldsDetail.type,required:false,minlength: this.groupfFieldsDetail.minLength,maxlength: this.groupfFieldsDetail.maxLength}});
								}


							  }, error => {

							  });
						}
					  }, error => {

					  });

				}else{
					this.toastr.error('Group Already exist!');
				}
			}
		}else{
			this.toastr.error('Tab Required');
		}

	}

	addGroupToSection(activeTabID, groupData , groupIndex ,event){
		var activeSectionId;
		if(event){
			let group={"name":groupData.groupName,"fields":[]};
			 activeSectionId = this.values[activeTabID]["sections"].length-1;
			//alert(activeSectionId);
			this.values[activeTabID]["sections"][activeSectionId]["groups"].push(group);
			for(let i = 0; i<this.groups.length ; i++){
				if(groupData.groupName == this.groups[i]["name"]){
					this.groupPopArray.push(this.groups[i]);
					this.groups.splice(i,1);
				}
			}
		}
		else{
			activeSectionId = this.values[activeTabID]["sections"].length-1;
			for(let i=0;i<this.values[activeTabID]["sections"][activeSectionId]["groups"].length;i++){
				if(groupData.groupName == this.values[activeTabID]["sections"][activeSectionId]["groups"][i].name){
					this.groups.push({"id":groupData.id,"name":groupData.groupName,"key":groupData.key});
					this.values[activeTabID]["sections"][activeSectionId]["groups"].splice(i, 1);
				}
			}

		}
	}

	addAllGroupsToSection(activeTabID , event , data){
		var activeSectionId;
		if(event){
			activeSectionId = this.values[activeTabID]["sections"].length-1;
			this.isAllGroupsSelected = true;
			for(let i=0; i<data.length;i++){
				let group={"name":data[i].groupName,"fields":[]};
				this.values[activeTabID]["sections"][activeSectionId]["groups"].push(group);
				for(let j=0; j<this.groups.length;j++){
					if(data[i].groupName == this.groups[j]["name"]){
						this.groupPopArray.push(this.groups[j]);
						this.groups.splice(j,1);
					}
				}
			}

		}else{
			this.isAllGroupsSelected = false;
			activeSectionId = this.values[activeTabID]["sections"].length-1;
			for(let i=0; i<data.length;i++){
				for(let j=0;j<this.values[activeTabID]["sections"][activeSectionId]["groups"].length;j++){
					if(data[i].groupName == this.values[activeTabID]["sections"][activeSectionId]["groups"][j].name){
						this.groups.push({"id":data[i].id,"name":data[i].groupName,"key":data[i].key});
						this.values[activeTabID]["sections"][activeSectionId]["groups"].splice(j,1);
					}
				}
			}
		}
	}

	searchGroupWithoutSection(searchValue,activeTabID){
		let flagGroup = false;
		for (let i=0; i < this.values[activeTabID]["groups"].length; i++) {
			if (this.values[activeTabID]["groups"][i].name === searchValue) {
				flagGroup = true;
				break;
			}else{
				flagGroup =  false;
			}
		}
		return flagGroup;
	}

	searchGroupInsideSection(searchValue,activeTabID,activeSection){
		let flagInsideGroup = false;
		for (let i=0; i < this.values[activeTabID]["sections"][activeSection]["groups"].length; i++) {
			if (this.values[activeTabID]["sections"][activeSection]["groups"][i].name === searchValue) {
				flagInsideGroup = true;
				break;
			}else{
				flagInsideGroup =  false;
			}
		}
		return flagInsideGroup;
	}


	addFields(f,activeTabID,activeSectionId)
	{
		if(this.values.length>0){
		   var res_split_field = '';
		   if(activeSectionId != undefined ){
				var res_field = activeSectionId.toString();
				res_split_field = res_field.split("-");
			}
			if(typeof activeSectionId == "undefined" && this.whichActive!="group"){
				let fieldInsideTabs = this.searchFieldInsideTabs(f.name,activeTabID);
					var fType ='';
					if ( f.fieldType == undefined) {
						fType = f.type;
					}else{
						fType = f.fieldType;
					}
				if(!fieldInsideTabs){
					if(fType=="select" || fType=="radio"){
						this.values[activeTabID]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
					}else{
						if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
						this.values[activeTabID]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
					}

					for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
				}else{
					this.toastr.error('Field Already exist!');
				}
			}
			else if(this.values[activeTabID]["sections"].length == 0 && this.values[activeTabID]["groups"].length > 0){
				//alert("here");
				//console.log(f);
				let fieldInsideGroup = this.searchFieldInsideGroup(f.name,activeTabID,this.activeGroupId);
				var fType ='';
					if ( f.fieldType == undefined) {
						fType = f.type;
					}else{
						fType = f.fieldType;
					}
				if(!fieldInsideGroup){
					if(fType=="select" || fType=="radio"){
						this.values[activeTabID]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
					}else{
						if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
						this.values[activeTabID]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
					}
					for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
				}else{
					this.toastr.error('Field Already exist!');
				}

			}
			else if(this.values[activeTabID]["sections"].length==0 && this.values[activeTabID]["groups"].length == 0){
				//alert("there");
				let fieldInsideTabs = this.searchFieldInsideTabs(f.name,activeTabID);
				var fType ='';
					if ( f.fieldType == undefined) {
						fType = f.type;
					}else{
						fType = f.fieldType;
					}
				if(!fieldInsideTabs){
					if(fType=="select" || fType=="radio"){
						this.values[activeTabID]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
					}else{
						if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
						this.values[activeTabID]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
					}

					for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
				}else{
					this.toastr.error('Field Already exist!');
				}
			}
			else if(typeof activeSectionId == "undefined" || this.values[activeTabID]["sections"][res_split_field[1]]["groups"].length == 0 ){
				//alert("hurray");
				//alert(this.whichActive);
				if(this.whichActive=="group"){
					let fieldInsideGroup1 = this.searchFieldInsideGroup(f.name,activeTabID,this.activeGroupId);
					var fType ='';
					if ( f.fieldType == undefined) {
						fType = f.type;
					}else{
						fType = f.fieldType;
					}
					if(!fieldInsideGroup1){
						if(fType=="select" || fType=="radio"){
							this.values[activeTabID]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
						}else{
							if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
							this.values[activeTabID]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
						}
						for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
					}else{
						this.toastr.error('Field Already exist!');
					}
				}else{
					 let fieldInsideSection = this.searchFieldInsideSection(f.name,activeTabID,res_split_field[1]);
					 var fType ='';
						if ( f.fieldType == undefined) {
							fType = f.type;
						}else{
							fType = f.fieldType;
						}
					 if(!fieldInsideSection){
						if(fType=="select" || fType=="radio"){
							this.values[activeTabID]["sections"][res_split_field[1]]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
						}else{
							if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
							this.values[activeTabID]["sections"][res_split_field[1]]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
						}
						for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
					 }else{
						this.toastr.error('Field Already exist!');
					 }

				}
			}
			else{
				//alert("ithe");
				let fieldInsideSectionGroup = this.searchFieldInsideSectionGroup(f.name,activeTabID,res_split_field[1],this.activeGroupId);
				var fType ='';
				if ( f.fieldType == undefined) {
					fType = f.type;
				}else{
					fType = f.fieldType;
				}
				if(!fieldInsideSectionGroup){
					if(fType=="select" || fType=="radio"){
						this.values[activeTabID]["sections"][res_split_field[1]]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,options:[]}});
					}else{
						if(f.templateOptions==undefined){
							//alert("optionsUndefined");
							var fmaxlength ='';
							if ( f.maxLength == undefined) {
								fmaxlength = f.maxlength;
							}else{
								 fmaxlength = f.maxLength;
							}

							var fminlength ='';
							if ( f.minLength == undefined) {
								fminlength = f.minlength;
							}else{
								 fminlength = f.minLength;
							}
						}else{
							//alert("optionsDefined");
							 fmaxlength =f.templateOptions.maxlength
							 fminlength =f.templateOptions.minlength
						}
						this.values[activeTabID]["sections"][res_split_field[1]]["groups"][this.activeGroupId]["fields"].push({"className":f.className,"key":f.key,"name":f.name,"type":fType,"defaultValue":f.defaultValue,templateOptions:{label:f.name,type:fType,required:false,maxlength:fmaxlength,minlength:fminlength}});
					}
					for(let i = 0; i<this.fields.length ; i++){
						if(f.name == this.fields[i]["name"]){
							this.fields.splice(i,1);
						}
					}
				}else{
					this.toastr.error('Field Already exist!');
				}

			}
		}else{
			this.toastr.error('Tab Required!');
		}
	}

	searchFieldInsideGroup(searchValue,activeTabID,activeGroup){
		let flagFieldInsideGroup = false;
		for (let i=0; i < this.values[activeTabID]["groups"][activeGroup]["fields"].length; i++) {
			if (this.values[activeTabID]["groups"][activeGroup]["fields"][i].name === searchValue) {
				flagFieldInsideGroup = true;
				break;
			}else{
				flagFieldInsideGroup =  false;
			}
		}
		return flagFieldInsideGroup;
	}

	searchFieldInsideTabs(searchValue,activeTabID){
		let flagFieldInsideTabs = false;
		for (let i=0; i < this.values[activeTabID]["fields"].length; i++) {
			if (this.values[activeTabID]["fields"][i].name === searchValue) {
				flagFieldInsideTabs = true;
				break;
			}else{
				flagFieldInsideTabs =  false;
			}
		}
		return flagFieldInsideTabs;
	}

	searchFieldInsideSection(searchValue,activeTabID,activeSection){
		let flagFieldInsideSection = false;
		for (let i=0; i < this.values[activeTabID]["sections"][activeSection]["fields"].length; i++) {
			if (this.values[activeTabID]["sections"][activeSection]["fields"][i].name === searchValue) {
				flagFieldInsideSection = true;
				break;
			}else{
				flagFieldInsideSection =  false;
			}
		}
		return flagFieldInsideSection;
	}

	searchFieldInsideSectionGroup(searchValue,activeTabID,activeSection,activeGroup){
		let flagFieldInsideSectionGroup = false;
		for (let i=0; i < this.values[activeTabID]["sections"][activeSection]["groups"][activeGroup]["fields"].length; i++) {
			if (this.values[activeTabID]["sections"][activeSection]["groups"][activeGroup]["fields"][i].name === searchValue) {
				flagFieldInsideSectionGroup = true;
				break;
			}else{
				flagFieldInsideSectionGroup =  false;
			}
		}
		return flagFieldInsideSectionGroup;
	}

	templateNameBlur(event){
	}
	selected(event){
		this.templateId = event.item.id;
		this.templateService
		  .fetchTemplateById(this.templateId)
		  .subscribe(templateById => {
			this.templateById = templateById;
			if (this.templateById) {
				//let jsonFormattedString = this.templateById.templateData.replaceAll("\\\\", "");
				this.values=[];
				this.temp=[];
				this.temp.push(this.templateById.templateData);
				this.values = this.temp[0];
			}
		  }, error => {

		  });
	}

	requiredFieldInsideTab(activeTabID,k,event){
		if(event){
			this.values[activeTabID]["fields"][k]["templateOptions"].required = true;
		}else{
			this.values[activeTabID]["fields"][k]["templateOptions"].required = false;
		}
	}

	allrequiredFieldInsideTab(activeTabID,k,event){
		if(event){
			for(let d=0; d<this.values[activeTabID]["fields"].length;d++){
				this.values[activeTabID]["fields"][d]["templateOptions"].required = true;
			}
		}else{
			for(let d=0; d<this.values[activeTabID]["fields"].length;d++){
				this.values[activeTabID]["fields"][d]["templateOptions"].required = false;
			}
		}
	}
	requiredFieldInsideGroup(activeTabID,l,event){
		if(event){
			this.values[activeTabID]["groups"][this.activeGroupId]["fields"][l]["templateOptions"].required=true;
		}else{
			this.values[activeTabID]["groups"][this.activeGroupId]["fields"][l]["templateOptions"].required=false;
		}
	}

	allrequiredFieldInsideGroup(activeTabID,event){
		if(event){
			for(let e=0 ;e<this.values[activeTabID]["groups"][this.activeGroupId]["fields"].length;e++){
				this.values[activeTabID]["groups"][this.activeGroupId]["fields"][e]["templateOptions"].required=true;
			}

		}else{
			for(let e=0 ;e<this.values[activeTabID]["groups"][this.activeGroupId]["fields"].length;e++){
				this.values[activeTabID]["groups"][this.activeGroupId]["fields"][e]["templateOptions"].required=false;
			}
		}
	}

	requiredFieldInsideSection(activeTabID,activeSectionID,activeFieldID,event){
		if(event){
			this.values[activeTabID]["sections"][activeSectionID]["fields"][activeFieldID]["templateOptions"].required=true;
		}else{
			this.values[activeTabID]["sections"][activeSectionID]["fields"][activeFieldID]["templateOptions"].required=false;
		}
	}

	allrequiredFieldInsideSection(activeTabID,activeSectionID,event){
		if(event){
			for(let f=0;f<this.values[activeTabID]["sections"][activeSectionID]["fields"].length;f++){
				this.values[activeTabID]["sections"][activeSectionID]["fields"][f]["templateOptions"].required=true;
			}
		}else{
			for(let f=0;f<this.values[activeTabID]["sections"][activeSectionID]["fields"].length;f++){
				this.values[activeTabID]["sections"][activeSectionID]["fields"][f]["templateOptions"].required=false;
			}
		}
	}

	requiredFieldInsideSectionGroup(activeTabID,activeSectionID,activeFieldID,event){
		if(event){
			this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"][activeFieldID]["templateOptions"].required=true;
		}else{
			this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"][activeFieldID]["templateOptions"].required=false;
		}
	}

	allrequiredFieldInsideSectionGroup(activeTabID,activeSectionID,event){
		if(event){
			for(let g=0 ; g<this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"].length;g++){
				this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"][g]["templateOptions"].required=true;
			}
		}else{
			for(let g=0 ; g<this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"].length;g++){
				this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"][g]["templateOptions"].required=false;
			}
		}
	}

	getBackgroundColor(check){
		if(check){
			return "yellow";
		}else{
			return "white";
		}
	}

	removeFieldInsideTab(activeTabID , fieldIndexToRemove,FieldName){
		this.fields.push(FieldName);
		this.values[activeTabID]["fields"].splice(fieldIndexToRemove, 1);
	}

	removeFieldInsideGroup(activeTabID ,  fieldIndexToRemove ,FieldName){
		this.fields.push(FieldName);
		this.values[activeTabID]["groups"][this.activeGroupId]["fields"].splice(fieldIndexToRemove, 1);
	}

	removeGroupInsideTab(activeTabID ,  groupIndexToRemove, groupName){
		this.groups.push(groupName);
		this.values[activeTabID]["groups"].splice(groupIndexToRemove, 1);
	}

	removeFieldInsideSection(activeTabID ,  activeSectionID , fieldIndexToRemove , FieldName){
		this.fields.push(FieldName);
		this.values[activeTabID]["sections"][activeSectionID]["fields"].splice(fieldIndexToRemove, 1);
	}

	removeGroupInsideSection(activeTabID ,  activeSectionID , fieldIndexToRemove,groupName){
		this.groups.push(groupName);
		this.values[activeTabID]["sections"][activeSectionID]["groups"].splice(fieldIndexToRemove, 1);
	}

	removeFieldInsideSectionGroup(activeTabID ,  activeSectionID , fieldIndexToRemove,FieldName){
		this.fields.push(FieldName);
		this.values[activeTabID]["sections"][activeSectionID]["groups"][this.activeGroupId]["fields"].splice(fieldIndexToRemove, 1);
	}

	removeSection(activeTabID ,  sectionIndexToRemove, sectionName){
		this.sections.push(sectionName);
		this.values[activeTabID]["sections"].splice(sectionIndexToRemove, 1);
		return false;
	}

	removeTab(tabIndexToRemove, tabName){
		this.tabs.push(tabName);
		this.values.splice(tabIndexToRemove, 1);
		return false;
	}
	 // for field inside tabs

	openPopupFieldInsideTabs(activeTabId , fieldData , fieldIndex){
		if(fieldData.type=="select" || fieldData.type=="radio"){
			this.activeTabIdFieldInsideTab = activeTabId;
			this.dataFieldInsideTab = fieldData;
			this.activeFieldInsideTab = fieldIndex;
			this.activeFieldInsideTabType = fieldData.type;
			this.popupForFieldsInTabs = true;

			this.fieldInsideTabArray =[];
			for(var i =0; i<this.values[activeTabId]["fields"][fieldIndex]["templateOptions"]["options"].length; i++){
				if(this.activeFieldInsideTabType=="select"){
					var t1 : FieldInsideTab = new FieldInsideTab(i,this.values[activeTabId]["fields"][fieldIndex]["templateOptions"]["options"][i]["label"],this.values[activeTabId]["fields"][fieldIndex]["templateOptions"]["options"][i]["value"]);
					this.fieldInsideTabArray.push(t1);
				}else{
					var t1 : FieldInsideTab = new FieldInsideTab(i,'',this.values[activeTabId]["fields"][fieldIndex]["templateOptions"]["options"][i]["value"],this.values[activeTabId]["fields"][fieldIndex]["templateOptions"]["options"][i]["key"]);
					this.fieldInsideTabArray.push(t1);
				}
			}
			if(this.fieldInsideTabArray.length==0){
				var t : FieldInsideTab = new FieldInsideTab(0,'','');
				this.fieldInsideTabArray.push(t);
			}
		}

		return false;
	}

	AddOptionsFieldInsideTabs(){
		this.values[this.activeTabIdFieldInsideTab]["fields"][this.activeFieldInsideTab]["templateOptions"]["options"]=[];
		if(this.activeFieldInsideTabType=="select"){
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideTab]["fields"][this.activeFieldInsideTab]["templateOptions"]["options"].push({"label":this.fieldInsideTabArray[i].label,"value":this.fieldInsideTabArray[i].value});
			}
		}else{
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideTab]["fields"][this.activeFieldInsideTab]["templateOptions"]["options"].push({"key":this.fieldInsideTabArray[i].key,"value":this.fieldInsideTabArray[i].value});
			}
		}
		this.popupForFieldsInTabs = false;
	}

	AddMoreOptionsFInsideTab(h){
		console.log(h);
		console.log(this.fieldInsideTabArray);
		h = h + 1;
		this.fieldInsideTabArray.push(new FieldInsideTab(h , '', ''));
	}

	close(){
		this.popupForFieldsInTabs = false;
	}

	// ends here

	// for fields inside Groups
	openPopupFieldInsideGroups(activeTabId , fieldData , fieldIndex){
		if(fieldData.type=="select" || fieldData.type=="radio"){
			this.popupForFieldsInGroups = true;
			this.activeTabIdFieldInsideGroup = activeTabId;
			this.dataFieldInsideGroup = fieldData;
			this.activeFieldInsideGroup = fieldIndex;
			this.activeFieldInsideGroupType = fieldData.type;

			this.fieldInsideTabArray =[];
			for(var i =0; i<this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"].length; i++){
				if(this.activeFieldInsideGroupType=="select"){
					var t1 : FieldInsideTab = new FieldInsideTab(i,this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"][i]["label"],this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"][i]["value"]);
					this.fieldInsideTabArray.push(t1);
				}else{
					var t1 : FieldInsideTab = new FieldInsideTab(i,'',this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"][i]["value"],this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"][i]["key"]);
					this.fieldInsideTabArray.push(t1);
				}
			}
			if(this.fieldInsideTabArray.length==0){
				var t : FieldInsideTab = new FieldInsideTab(0,'','');
				this.fieldInsideTabArray.push(t);
			}
		}
		return false;
	}

	AddOptionsFieldInsideGroups(){
		this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"]=[];
		if(this.activeFieldInsideGroupType=="select"){
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"].push({"label":this.fieldInsideTabArray[i].label,"value":this.fieldInsideTabArray[i].value});
			}
		}else{
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideGroup]["templateOptions"]["options"].push({"key":this.fieldInsideTabArray[i].key,"value":this.fieldInsideTabArray[i].value});
			}
		}
		this.popupForFieldsInGroups = false;
	}

	close_group_field(){
		this.popupForFieldsInGroups = false;
	}
	// ends here

	// For field inside Sections

	openPopupFieldInsideSections(activeTabId , activeSectionId, fieldData , fieldIndex){
		if(fieldData.type=="select" || fieldData.type=="radio"){
			this.popupForFieldsInSections = true;
			this.activeTabIdFieldInsideSection = activeTabId;
			this.activeSectionIdFieldInsideSection = activeSectionId;
			this.dataFieldInsideSection = fieldData;
			this.activeFieldInsideSection = fieldIndex;
			this.activeFieldInsideSectionType = fieldData.type;

			this.fieldInsideTabArray =[];
			for(var i =0; i<this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"].length; i++){
				if(this.activeFieldInsideSectionType=="select"){
					var t1 : FieldInsideTab = new FieldInsideTab(i,this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"][i]["label"],this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"][i]["value"]);
					this.fieldInsideTabArray.push(t1);
				}else{
					var t1 : FieldInsideTab = new FieldInsideTab(i,'',this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"][i]["value"],this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"][i]["key"]);
					this.fieldInsideTabArray.push(t1);
				}
			}
			if(this.fieldInsideTabArray.length==0){
				var t : FieldInsideTab = new FieldInsideTab(0,'','');
				this.fieldInsideTabArray.push(t);
			}
		}
		return false;

	}

	AddOptionsFieldInsideSections(){
		this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"]=[];
		if(this.activeFieldInsideSectionType=="select"){
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"].push({"label":this.fieldInsideTabArray[i].label,"value":this.fieldInsideTabArray[i].value});
			}
		}else{
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideSection]["sections"][this.activeSectionIdFieldInsideSection]["fields"][this.activeFieldInsideSection]["templateOptions"]["options"].push({"key":this.fieldInsideTabArray[i].key,"value":this.fieldInsideTabArray[i].value});
			}
		}
		this.popupForFieldsInSections = false;
	}

	close_section_field(){
		this.popupForFieldsInSections = false;
	}

	// ends here

	// for fields inside section groups
	openPopupFieldInsideSectionsGroups(activeTabId , activeSectionId, fieldData , fieldIndex){
		if(fieldData.type=="select" || fieldData.type=="radio"){
			this.popupForFieldsInSectionsGroup = true;
			this.activeTabIdFieldInsideSectionGroup = activeTabId;
			this.activeSectionIdFieldInsideSectionGroup = activeSectionId;
			this.dataFieldInsideSectionGroup = fieldData;
			this.activeFieldInsideSectionGroup = fieldIndex;
			this.activeFieldInsideSectionGroupType = fieldData.type;

			this.fieldInsideTabArray =[];
			for(var i =0; i<this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"].length; i++){
				if(this.activeFieldInsideSectionGroupType=="select"){
					var t1 : FieldInsideTab = new FieldInsideTab(i,this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"][i]["label"],this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"][i]["value"]);
					this.fieldInsideTabArray.push(t1);
				}else{
					var t1 : FieldInsideTab = new FieldInsideTab(i,'',this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"][i]["value"],this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"][i]["key"]);
					this.fieldInsideTabArray.push(t1);
				}
			}
			if(this.fieldInsideTabArray.length==0){
				var t : FieldInsideTab = new FieldInsideTab(0,'','');
				this.fieldInsideTabArray.push(t);
			}
		}
		return false;
	}

	AddOptionsFieldInsideSectionsGroups(){
		this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"]=[];
		if(this.activeFieldInsideSectionGroupType=="select"){
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"].push({"label":this.fieldInsideTabArray[i].label,"value":this.fieldInsideTabArray[i].value});
			}
		}else{
			for(let i=0; i<this.fieldInsideTabArray.length;i++){
				this.values[this.activeTabIdFieldInsideSectionGroup]["sections"][this.activeSectionIdFieldInsideSectionGroup]["groups"][this.activeGroupId]["fields"][this.activeFieldInsideSectionGroup]["templateOptions"]["options"].push({"key":this.fieldInsideTabArray[i].key,"value":this.fieldInsideTabArray[i].value});
			}
		}
		this.popupForFieldsInSectionsGroup = false;
	}

	close_section_group_field(){
		this.popupForFieldsInSectionsGroup = false;
	}

	close_TabSectionPopup(){
		this.sectionsPopup = false;
	}
	close_groupsPopup(){
		this.gropusPopup = false;
	}

	// for typeahead
	nameInputFormatter = (result: { name: string }) => result.name
	formatter = (result: { name: string }) => result.name
	searchByTemplate = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.templates.filter(v => v.name.indexOf(term) > -1).slice(0, 10));


	ngOnInit(): void {

	}

	setLocalVariable(id){
		this.activeSectionId = id;
	}
	search(){
		let searchData = this.searchField;
		let searchResult = [];
		this.fields = this.originalFieldsArray;
		if(searchData){
			for(let i=0; i<this.fields.length;i++){
				if (this.fields[i].name.toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.fields[i]);
				}
			}
			this.fields=[];
			this.fields= searchResult;
		}else{
			this.fields = this.originalFieldsArray;
		}
	}
	searchGroupName(){
		let searchData = this.searchGroup;
		let searchResult = [];
		this.groups = this.originalGroupsArray;
		if(searchData){
			for(let i=0; i<this.groups.length;i++){
				if (this.groups[i].name.toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.groups[i]);
				}
			}
			this.groups=[];
			this.groups= searchResult;
		}else{
			this.groups = this.originalGroupsArray;
		}
	}
	searchSectionName(){
		let searchData = this.searchSectionValue;
		let searchResult = [];
		this.sections = this.originalSectionsArray;
		if(searchData){
			for(let i=0; i<this.sections.length;i++){
				if (this.sections[i].name.toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.sections[i]);
				}
			}
			this.sections=[];
			this.sections= searchResult;
		}else{
			this.sections = this.originalSectionsArray;
		}
	}
	searchTabName(){
		let searchData = this.searchTabValue;
		let searchResult = [];
		this.sections = this.originalTabArray;
		if(searchData){
			for(let i=0; i<this.tabs.length;i++){
				if (this.tabs[i].name.toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.tabs[i]);
				}
			}
			this.tabs=[];
			this.tabs= searchResult;
		}else{
			this.tabs = this.originalTabArray;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/create.component.ts